import React, { useState, useRef, useEffect } from 'react';
import { ChevronDown, ChevronUp, MoreVertical } from 'react-feather';
import { getDropdownStyles } from './styleUtils';
import { theme } from './theme';
import './Dropdown.css';

interface DropdownProps {
	label: string;
	children: React.ReactNode;
	direction?: 'up' | 'down';
	type?: 'button' | 'icon' | React.ReactNode;
}

const Dropdown: React.FC<DropdownProps> = ({
	label,
	children,
	direction = 'down',
	type = 'button'
}) => {
	const [isOpen, setIsOpen] = useState(false);
	const dropdownRef = useRef<HTMLDivElement>(null);
	const dynamicStyles = getDropdownStyles(theme);
	const toggleDropdown = () => setIsOpen(!isOpen);

	const componentStyles = () => {
		const baseStyles = type === 'button' ? dynamicStyles.dropDownButton_css : {};
		const openStyles = isOpen ? dynamicStyles.dropDownOpen_css : {};
		return {
			...baseStyles,
			...openStyles
		};
	};
	useEffect(() => {
		const handleClickOutside = (event: MouseEvent) => {
			if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
				setIsOpen(false);
			}
		};

		document.addEventListener('mousedown', handleClickOutside);
		return () => {
			document.removeEventListener('mousedown', handleClickOutside);
		};
	}, []);

	const dropdownIcon = () => {
		return isOpen ? <ChevronUp size={20} /> : <ChevronDown size={20} />;
	};

	const buttonTypes = {
		icon: <MoreVertical size={20} color="rgba(152, 162, 179, 1)" />,
		button: (
			<>
				{label} {dropdownIcon()}
			</>
		)
	};

	return (
		<div className="dropdown" ref={dropdownRef}>
			<button
				style={componentStyles()}
				className={`${type == 'button' ? 'dropdown-button-toggle' : ''}`}
				onClick={toggleDropdown}
				aria-haspopup="true"
				aria-expanded={isOpen}
				aria-label={type === 'icon' ? label : ''}
			>
				{buttonTypes[type as keyof typeof buttonTypes] || type}
			</button>
			{isOpen && (
				<div
					className={`dropdown-content ${direction === 'up' ? 'up' : 'down'}`}
					style={dynamicStyles.dropDownContent_css}
				>
					{children}
				</div>
			)}
		</div>
	);
};

export default Dropdown;
